'use strict';

import modalCuentaController from './modal/cuenta.controller';
import modalCuentaTemplate from './modal/cuenta.html';

class NavbarController {
    constructor($state, $window, Util, Auth, Storage, SidenavFactory, Modal, $log) {
        "ngInject";

        this.$state = $state;
        this.$window = $window;
        this.Util = Util;
        this.Auth = Auth;
        this.$log = $log;
        this.Storage = Storage;
        this.SidenavFactory = SidenavFactory;
        this.Modal = Modal;
    }

    $onInit() {
        this.user = this.Storage.getUser();
        window.setTimeout(() => {
          if(this.$window.innerWidth<990) {
            document.querySelector('#app-sidenav').classList.toggle('sidenav-close');
          }
        }, 750);
    }

    toggleSidenav() {
        document.querySelector('#app-sidenav').classList.toggle('sidenav-close');
    }

    fullscreen() {
        document.querySelector('body').classList.toggle('fullscreen');
        this.Util.fullscreen();
    }

    refresh() {
        this.$state.reload();
    }

    toggled(open) {
        this.$log.log('open', open);
    }

    logout() {
        this.Auth.logout();
    }

    account() {
        //this.Sidenav.path("account");
        this.Modal.show({
        template: modalCuentaTemplate,
        controller: modalCuentaController,
        data: {},
        size: ''
      })
      .result.then(() => {
        this.logout();
      });
    }

    changeRol(rol) {
        this.user.rol = rol;
        this.refresh();
        // Set rol
        this.SidenavFactory.setRol(rol);
        this.Storage.set('rol', this.SidenavFactory.getRol());
        this.Storage.setUser(this.user);
    }
}

export default NavbarController;


// WEBPACK FOOTER //
// ./src/app/common/layout/navbar/navbar.controller.js